import {
  FACEBOOK_ALBUM_NAME,
  FACEBOOK_PLATFORM,
  IWixWizFacebookMedia,
  IWixWizSiteMedia,
} from './wixWiz';

const MAX_IMAGES_AMOUNT = 48;

const normalizeSiteData = (siteDataRaw: IWixWizSiteMedia) => {
  let images = [];
  let logo;

  if (
    !siteDataRaw ||
    !siteDataRaw.pages ||
    !siteDataRaw.pages.length ||
    !siteDataRaw.pages[0].images
  ) {
    return {};
  }

  images = siteDataRaw.pages[0].images;
  if (siteDataRaw.pages[0].sections) {
    const header = siteDataRaw.pages[0].sections.find(
      (section) => section.type === 'header',
    );
    if (header) {
      logo = header.logo;
    }
  }

  return { photos: images.slice(0, MAX_IMAGES_AMOUNT), logo };
};

const normalizeFacebookData = (
  facebookDataRaw: IWixWizFacebookMedia,
): { photos?: string[]; logo?: string } => {
  let images: string[] = [];
  let logo;

  if (
    !facebookDataRaw ||
    !facebookDataRaw.platforms ||
    !facebookDataRaw.platforms.length
  ) {
    return {};
  }

  const facebookPlatform = facebookDataRaw.platforms.find(
    (p) => p.platform_name === FACEBOOK_PLATFORM,
  );
  if (
    !facebookPlatform ||
    !facebookPlatform.photos_albums ||
    !facebookPlatform.photos_albums.length
  ) {
    return {};
  }

  const album = facebookPlatform.photos_albums.find(
    (a) => a.name === FACEBOOK_ALBUM_NAME,
  );

  if (facebookPlatform.general_info) {
    logo = facebookPlatform.general_info.logo;
  }
  if (album && album.photos && album.photos.length) {
    images = album.photos.map((photo) => photo.photo_url);
  }

  return { photos: images.slice(0, MAX_IMAGES_AMOUNT), logo };
};

export { normalizeSiteData, normalizeFacebookData };
